module.exports = __webpack_public_path__ + "static/media/wallet.ea32348e.svg";